import { Box, theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

const SliderDot = styled.div`
  cursor: pointer;

  width: 6px;
  height: 6px;
  margin: 0 4px;
  border-radius: 50%;

  background-color: ${theme.colors.neutral[700]};
`;

const SelectedDot = styled(SliderDot)`
  background-color: ${theme.colors.primary[400]};
`;

type CarouselDotsProps = {
  dotsQuantity: number;
  currentIndex: number;
  onClick: (index: number) => void;
  dataClick?: string;
  dataFrom?: string;
};

export const CarouselDots = ({
  dotsQuantity,
  currentIndex,
  onClick,
  dataClick,
  dataFrom,
}: CarouselDotsProps) => (
  <Box alignItems="center" display="flex" flex={1} justifyContent="center">
    {Array.from({ length: dotsQuantity }, (_, index) => {
      const onClickDot = () => onClick(index);
      return (
        <div key={index}>
          {index === currentIndex ? (
            <SelectedDot data-click={dataClick} data-from={dataFrom} onClick={onClickDot} />
          ) : (
            <SliderDot data-click={dataClick} data-from={dataFrom} onClick={onClickDot} />
          )}
        </div>
      );
    })}
  </Box>
);
